import React from 'react';
import { useField, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Box, Typography } from '@mui/material';

const Dringlichkeit = () => {
  const [dringlichkeitField, , dringlichkeithelpers] = useField('dringlichkeit');
  const [, , dringlichkeitDAYShelpers] = useField('dringlichkeitDAYS');


  const DAYS_BY_URGENCY = {
    'Gefahr in Verzug': 0,
    'Eingeschränkte Funktion': 7,
    'Schönheitsreparatur': 14,
  };

  const selectUrgency = (val) => {
    dringlichkeithelpers.setValue(val);
    const days = DAYS_BY_URGENCY[val] ?? 0;
    dringlichkeitDAYShelpers.setValue(days);
  };

  // Responsive Karte: Desktop unverändert, Mobil invertiert + ohne Haken
  const RadioBox = ({ vorlaufzeit, label, sublabel, value }) => {
  const isChecked = dringlichkeitField.value === value;

  return (
    <FormControlLabel
      className={isChecked ? 'checked-box' : 'unchecked-box'}
      sx={{
        m: 0,
        p: 0,
        width: '100%',
        alignItems: 'stretch',                       // <–
        border: 'none !important',
        background: 'transparent !important',
        '& .MuiFormControlLabel-label': {
          width: '100%',
          display: 'flex',                           // <–
        },
      }}
      control={
        <Radio
          checked={isChecked}
          onChange={() => selectUrgency(value)}
          value={value}
          sx={{ display: 'none' }}
        />
      }
      label={
        <Box
          onClick={() => selectUrgency(value)}
          sx={{
            flex: 1,                                  // <–
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: { xs: 2, md: 3 },
            borderRadius: 2,
            boxShadow: 1,
            '&:hover': { boxShadow: 2 },
            border: '1px solid',
            borderColor: isChecked ? '#3A8787' : '#E7EBF0',
            backgroundColor: { xs: isChecked ? '#2D2F31' : '#fff', md: '#fff' },
            color: { xs: isChecked ? '#fff' : 'inherit', md: 'inherit' },
            transition: 'background-color 120ms, box-shadow 120ms, border-color 120ms',
            cursor: 'pointer',
          }}
        >
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #ced5de',
                  mb: 3,
                }}
              >
                <Typography sx={{ color: '#8C939C' }} mb={3}>Vorlaufzeit</Typography>
                <Typography sx={{ color: '#3a8787', fontWeight: 'bold' }} mb={3}>
                  {vorlaufzeit}
                </Typography>
              </Box>

              <Typography variant="h6" mb={3}>{label}</Typography>
              <Typography dangerouslySetInnerHTML={sublabel} />
            </Box>

            {/* Haken nur auf Desktop */}
            {isChecked ? (
              <CheckRoundedIcon
                sx={{
                  display: { xs: 'none', md: 'inline-flex' },
                  fontSize: 60,
                  color: 'white',
                  p: 1.25,
                  backgroundColor: '#3A8787',
                  borderRadius: '50%',
                  border: '1px solid #3A8787',
                }}
              />
            ) : (
              <CheckRoundedIcon
                sx={{
                  display: { xs: 'none', md: 'inline-flex' },
                  fontSize: 60,
                  color: '#F0F2F5',
                  p: 1.25,
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  border: '1px solid #F0F2F5',
                }}
              />
            )}
          </Box>
        }
      />
    );
  };

  const sublabel1 = { __html: "<p>z.B. Wasserrohrbruch, Heizungsausfall usw. Handlungsbedarf <strong>sofort!</strong><br><br> Bitte wählen Sie die Notfallnummer des Handwerkers/Verwalters.</p>" };
  const sublabel2 = { __html: "<p>z.B. Rollladen klemmt, Videosprechanlage oder Steckdose geht nicht, Türe streift usw.<br><br> Handlungsbedarf binnen <strong>2 Wochen</strong> ab Eingang bei WEINBERGER!</p>" };
  const sublabel3 = { __html: "<p>z.B. Spannungsriss in Fliese oder Risse in Tapete usw.<br><br> Handlungsbedarf binnen <strong>1 Monat</strong> ab Eingang bei WEINBERGER!</p>" };

  return (
    <div>
      <h2>Dringlichkeit</h2>
      <p class="mb-0">Wählen Sie bitte die Dringlichkeit aus:<span className="MuiFormLabel-asterisk">*</span></p>
      <FormControl>
        <RadioGroup name="dringlichkeit">
          <Grid container spacing={2} mb={6} mt={1} alignItems="stretch">
            <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
              <RadioBox
                vorlaufzeit="Keine"
                label="Gefahr in Verzug"
                sublabel={sublabel1}
                value="Gefahr in Verzug"
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
              <RadioBox
                vorlaufzeit="min. 7 Tage"
                label="Eingeschränkte Funktion"
                sublabel={sublabel2}
                value="Eingeschränkte Funktion"
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
              <RadioBox
                vorlaufzeit="min. 14 Tage"
                label="Schönheitsreparatur"
                sublabel={sublabel3}
                value="Schönheitsreparatur"
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default Dringlichkeit;
